var _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCrown2 = function SvgCrown2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 80 80"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "crown-2_svg__i",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "rotate(51.54 .5 .5)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#cd5c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308,
    stopColor: "#8f4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#5c2900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#341700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#170a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908,
    stopColor: "#060200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crown-2_svg__k",
    cx: 0.503,
    cy: -1.033,
    r: 1.989,
    gradientTransform: "matrix(.413 0 0 1 .293 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646,
    stopColor: "#f7e0c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947,
    stopColor: "#e6952c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e38812"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crown-2_svg__a",
    cx: 0.203,
    cy: 0.023,
    r: 1.197,
    gradientTransform: "matrix(2.059 0 0 1 -.53 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff0b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crown-2_svg__o",
    cx: -3.039,
    cy: 0.224,
    r: 1.318,
    gradientTransform: "matrix(3.556 0 0 1 -1.278 0)",
    xlinkHref: "#crown-2_svg__a"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crown-2_svg__r",
    cx: -0.039,
    cy: -0.096,
    r: 2.444,
    gradientTransform: "matrix(1.009 0 0 1 -.005 0)",
    xlinkHref: "#crown-2_svg__a"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crown-2_svg__s",
    cx: -0.984,
    cy: 0.598,
    r: 1.971,
    gradientTransform: "matrix(1.09 0 0 1 -.045 0)",
    xlinkHref: "#crown-2_svg__a"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crown-2_svg__u",
    cx: 0.5,
    cy: 0.5,
    r: 6.927,
    gradientTransform: "matrix(.115 0 0 1 .442 0)",
    xlinkHref: "#crown-2_svg__a"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crown-2_svg__v",
    cx: 0.334,
    cy: -1.633,
    r: 5.082,
    gradientTransform: "matrix(.433 0 0 1 .283 0)",
    xlinkHref: "#crown-2_svg__b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crown-2_svg__w",
    cx: 0.292,
    cy: 0.05,
    r: 1.284,
    gradientTransform: "matrix(1.384 0 0 1 -.192 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8aaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d7001e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crown-2_svg__c",
    cx: -0.558,
    cy: 0.045,
    r: 2.164,
    gradientTransform: "matrix(3.936 0 0 1 -1.468 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f50022"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crown-2_svg__d",
    cx: 0.292,
    cy: -0.644,
    r: 2.526,
    gradientTransform: "matrix(.696 0 0 1 .152 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8a91"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crown-2_svg__x",
    cx: -0.027,
    cy: 3.031,
    r: 3.335,
    gradientTransform: "matrix(.58 0 0 1 .21 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb716d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#e35252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf0008"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crown-2_svg__y",
    cx: -1.29,
    cy: 0.031,
    r: 1.091,
    gradientTransform: "matrix(3.936 0 0 1 -1.468 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb716d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf0008"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crown-2_svg__z",
    cx: 0.145,
    cy: -0.116,
    r: 4.205,
    gradientTransform: "matrix(.696 0 0 1 .152 0)",
    xlinkHref: "#crown-2_svg__c"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crown-2_svg__A",
    cx: -0.099,
    cy: -2.448,
    r: 3.862,
    gradientTransform: "matrix(.58 0 0 1 .21 0)",
    xlinkHref: "#crown-2_svg__d"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crown-2_svg__G",
    cx: 0.34,
    cy: 0.363,
    r: 0.682,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fccd10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.221,
    stopColor: "#ecab08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449,
    stopColor: "#df8d02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#db8300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707,
    stopColor: "#d57c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#c76b00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ba5b00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crown-2_svg__e",
    cx: 0.16,
    cy: 0.107,
    r: 1.087,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe58a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crown-2_svg__H",
    cx: -0.204,
    cy: -0.244,
    r: 1.604,
    xlinkHref: "#crown-2_svg__e"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crown-2_svg__I",
    cx: 0.367,
    cy: 0.375,
    r: 0.926,
    gradientTransform: "matrix(1.3 0 0 1 -.15 0)",
    xlinkHref: "#crown-2_svg__e"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crown-2_svg__J",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.067,
    stopColor: "#e1d500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.212,
    stopColor: "#a69d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#736d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#4a4600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.637,
    stopColor: "#292700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    stopColor: "#121100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892,
    stopColor: "#040400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crown-2_svg__K",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.067,
    stopColor: "#e1784a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.212,
    stopColor: "#a65836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#733d26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#4a2718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.637,
    stopColor: "#29160d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    stopColor: "#120906"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892,
    stopColor: "#040201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "crown-2_svg__j",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e86900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fc8f00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "crown-2_svg__f",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcb30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "crown-2_svg__l",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#crown-2_svg__f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "crown-2_svg__m",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#crown-2_svg__f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "crown-2_svg__n",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.052,
    stopColor: "#ed9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#fc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.926,
    stopColor: "#b36600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "crown-2_svg__b",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "crown-2_svg__g",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "crown-2_svg__p",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#crown-2_svg__f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "crown-2_svg__q",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcb30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed8e00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "crown-2_svg__t",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#crown-2_svg__g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "crown-2_svg__B",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5d36c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff5b0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "crown-2_svg__C",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#crown-2_svg__f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "crown-2_svg__h",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a34900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f09c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "crown-2_svg__D",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f09c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a34900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "crown-2_svg__E",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#crown-2_svg__h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "crown-2_svg__F",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbf00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#db6a00"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 35356",
    transform: "translate(-73.852 -76.383)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1936",
    cx: 28.471,
    cy: 28.471,
    r: 28.471,
    transform: "rotate(-51.54 162.243 -15.995)",
    style: {
      fill: "url(#crown-2_svg__i)",
      isolation: "isolate",
      mixBlendMode: "screen",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 35355"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21506",
    d: "M122.756 92.261a3.641 3.641 0 0 0-1.583 6.919A30.32 30.32 0 0 1 116 109.188a10.085 10.085 0 0 1-16.457 0 30.321 30.321 0 0 1-5.164-10.008 3.64 3.64 0 1 0-2.29.294c-.068 4.268-2.139 11.374-5.663 13.517l2.229 8.211H126.9l2.229-8.211c-3.524-2.143-5.593-9.249-5.663-13.517a3.641 3.641 0 0 0-.707-7.212z",
    transform: "translate(6.075 7.671)",
    style: {
      fill: "url(#crown-2_svg__j)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21507",
    d: "M125.807 105.226a5.682 5.682 0 0 1-6.3-5.356 32.375 32.375 0 0 1-3.5 5.642 10.085 10.085 0 0 1-16.457 0 32.465 32.465 0 0 1-3.5-5.642 5.681 5.681 0 0 1-6.3 5.356 9.772 9.772 0 0 1-3.319 4.089l2.229 8.211h38.24l2.229-8.211a9.772 9.772 0 0 1-3.319-4.089z",
    transform: "translate(6.075 11.347)",
    style: {
      fill: "url(#crown-2_svg__k)",
      mixBlendMode: "multiply",
      fillRule: "evenodd",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21508",
    d: "M81.722 95.39a.864.864 0 0 1 .621-.747 4.2 4.2 0 0 1 2.6.712 4.524 4.524 0 0 1 1.906 3.054l-3.726.925-1.4-3.944z",
    transform: "translate(3.802 8.818)",
    style: {
      fill: "url(#crown-2_svg__f)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21509",
    d: "M102.473 86.215a5.07 5.07 0 0 0-5.073 5.069v.854h10.139v-.854a5.07 5.07 0 0 0-5.069-5.069z",
    transform: "translate(11.378 4.75)",
    style: {
      fill: "url(#crown-2_svg__l)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21510",
    d: "M121.591 95.39a.864.864 0 0 0-.621-.747 4.2 4.2 0 0 0-2.6.712 4.524 4.524 0 0 0-1.906 3.054l3.726.925 1.4-3.944z",
    transform: "translate(20.588 8.818)",
    style: {
      fill: "url(#crown-2_svg__m)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21511",
    d: "M129.659 111.81v6.179a2.034 2.034 0 0 1-.3 1.086c-1.875 3.149-10.659 5.612-21.453 5.612s-19.577-2.463-21.453-5.612a2.047 2.047 0 0 1-.3-1.086v-6.179c2.145 8.3 41.358 8.3 43.5 0z",
    transform: "translate(5.944 17.115)",
    style: {
      fill: "url(#crown-2_svg__n)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21512",
    d: "M110.05 86.791a5.07 5.07 0 0 1 2.04 9.709c1.415 6.4 4.261 14.781 10.5 16.77 5.323 1.7 10.285-2.861 11.88-6.937a4.2 4.2 0 0 1 3.908-7.156 194.281 194.281 0 0 0-6.576 25.437c-.642 3.533-10.168 6.314-21.751 6.314s-21.111-2.779-21.751-6.312a194.041 194.041 0 0 0-6.576-25.437 4.2 4.2 0 0 1 3.908 7.156c1.594 4.076 6.557 8.633 11.88 6.937 6.238-1.989 9.084-10.367 10.5-16.77a5.07 5.07 0 0 1 2.041-9.711z",
    transform: "translate(3.802 5.028)",
    style: {
      fill: "url(#crown-2_svg__n)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21513",
    d: "M92.7 124.3q-1.577-8.983-3.7-17.234a12.693 12.693 0 0 1-3.37-4.719 4.2 4.2 0 0 0-3.908-7.156 194.04 194.04 0 0 1 6.578 25.434c.251 1.379 1.854 2.643 4.4 3.672z",
    transform: "translate(3.802 9.02)",
    style: {
      fill: "url(#crown-2_svg__b)",
      mixBlendMode: "multiply",
      fillRule: "evenodd",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21514",
    d: "M112.795 109.484q-1.651 7.811-2.762 15.976c4.516-1.117 7.556-2.778 8.053-4.667v-.021c.013-.049.024-.1.033-.147a194.267 194.267 0 0 1 6.581-25.437 4.2 4.2 0 0 0-3.908 7.156c-1.2 3.055-4.283 6.382-8 7.14z",
    transform: "translate(17.48 9.02)",
    style: {
      fill: "url(#crown-2_svg__g)",
      mixBlendMode: "multiply",
      fillRule: "evenodd",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21515",
    d: "M99.415 122.815q-.489-10.042-1.692-19.906a10.113 10.113 0 0 1-4.09 2.576 7.626 7.626 0 0 1-3.884.2 143.72 143.72 0 0 1 2.739 15.97 49.656 49.656 0 0 0 6.928 1.157z",
    transform: "translate(7.68 12.815)",
    style: {
      fill: "url(#crown-2_svg__a)",
      fillRule: "evenodd",
      isolation: "isolate",
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21516",
    d: "M103.813 97.731c-.728 9.286-1.17 18.572-1.06 27.857a63.913 63.913 0 0 0 5.814-.494c.51-5.981 1.133-11.963 2-17.943-3.174-1.86-5.3-5.522-6.757-9.421z",
    transform: "translate(13.954 10.314)",
    style: {
      fill: "url(#crown-2_svg__o)",
      fillRule: "evenodd",
      isolation: "isolate",
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21517",
    d: "M112.7 110.109c5.323 1.7 10.285-2.861 11.88-6.937-.853 3.263-3.279 7.226-7.373 8.334-10.242 2.769-14.53-10.272-15.006-18.167 1.415 6.4 4.261 14.781 10.5 16.77z",
    transform: "translate(13.694 8.192)",
    style: {
      fill: "url(#crown-2_svg__p)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21518",
    d: "M96.237 110.109c-5.323 1.7-10.285-2.861-11.88-6.937.853 3.263 3.279 7.226 7.373 8.334 10.242 2.769 14.53-10.272 15.006-18.167-1.415 6.4-4.261 14.781-10.5 16.77z",
    transform: "translate(5.075 8.192)",
    style: {
      fill: "url(#crown-2_svg__q)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21519",
    d: "M90.561 121.739v-5.772c-2.551-1.029-4.154-2.293-4.4-3.672v5.459a2.047 2.047 0 0 0 .3 1.086 8.476 8.476 0 0 0 4.107 2.9z",
    transform: "translate(5.944 17.35)",
    style: {
      fill: "url(#crown-2_svg__b)",
      mixBlendMode: "multiply",
      fillRule: "evenodd",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21520",
    d: "M91.6 115.551v5.8a48.246 48.246 0 0 0 6.928 1.188v-5.835a49.66 49.66 0 0 1-6.928-1.157z",
    transform: "translate(8.572 18.923)",
    style: {
      fill: "url(#crown-2_svg__r)",
      fillRule: "evenodd",
      isolation: "isolate",
      mixBlendMode: "screen",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21521",
    d: "M102.747 116.675v5.842c2.045-.085 4-.258 5.814-.507v-5.829a63.913 63.913 0 0 1-5.814.494z",
    transform: "translate(13.96 19.227)",
    style: {
      fill: "url(#crown-2_svg__s)",
      fillRule: "evenodd",
      isolation: "isolate",
      mixBlendMode: "screen",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21522",
    d: "M110.033 117.13v5.8c4-1.016 6.821-2.462 7.792-4.093a2.033 2.033 0 0 0 .3-1.086V112.3c-.356 1.958-3.441 3.686-8.09 4.835z",
    transform: "translate(17.48 17.35)",
    style: {
      fill: "url(#crown-2_svg__t)",
      mixBlendMode: "multiply",
      fillRule: "evenodd",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21523",
    d: "M127.547 113.714c-3.215 2.472-11.085 4.209-20.239 4.209s-17.022-1.737-20.237-4.209c2.88 2.726 10.873 4.673 20.237 4.673s17.358-1.947 20.239-4.673z",
    transform: "translate(6.386 18.035)",
    style: {
      fill: "url(#crown-2_svg__u)",
      opacity: 0.65,
      fillRule: "evenodd",
      isolation: "isolate",
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21524",
    d: "M101.557 93.766a5.063 5.063 0 0 1-2.041-.427c-.068.31-.139.626-.215.943a5.081 5.081 0 0 0 4.722.856c-.156-.613-.3-1.215-.426-1.8a5.063 5.063 0 0 1-2.041.427z",
    transform: "translate(12.295 8.192)",
    style: {
      fill: "url(#crown-2_svg__v)",
      mixBlendMode: "multiply",
      fillRule: "evenodd",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21525",
    d: "m96.088 106.86 7.021-3.515 7.021 3.515-.956 12.043-6.065 1.722-6.065-1.725-.956-12.043z",
    transform: "translate(10.743 13.026)",
    style: {
      fill: "#be8954",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21526",
    d: "m96.7 107.058 6.113-3.058 6.114 3.063-.862 10.86-5.252 1.493-5.252-1.491-.861-10.867z",
    transform: "translate(11.038 13.341)",
    style: {
      fill: "#e6e6e6",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21527",
    d: "m98.127 107.518.644 8.114 3.353.952 3.354-.953.644-8.111-4-2-4 2z",
    transform: "translate(11.727 14.075)",
    style: {
      fill: "url(#crown-2_svg__w)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21528",
    d: "m97.562 116.925 1.9-1.556-.644-8.114-2.118-1.194.862 10.865z",
    transform: "translate(11.038 14.338)",
    style: {
      fill: "url(#crown-2_svg__c)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21529",
    d: "m98.816 108.252 4-2V104l-6.116 3.058 2.116 1.194z",
    transform: "translate(11.038 13.341)",
    style: {
      fill: "url(#crown-2_svg__d)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21530",
    d: "m102.532 113.289-3.353-.952-1.9 1.556 5.252 1.491v-2.095z",
    transform: "translate(11.319 17.37)",
    style: {
      fill: "url(#crown-2_svg__x)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21531",
    d: "m104.981 116.925-1.9-1.556.644-8.114 2.116-1.194-.862 10.865z",
    transform: "translate(14.122 14.338)",
    style: {
      fill: "url(#crown-2_svg__y)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21532",
    d: "m104.819 108.252-4-2V104l6.114 3.061-2.116 1.194z",
    transform: "translate(13.029 13.341)",
    style: {
      fill: "url(#crown-2_svg__z)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21533",
    d: "m100.822 113.289 3.353-.952 1.9 1.556-5.252 1.491v-2.095z",
    transform: "translate(13.029 17.37)",
    style: {
      fill: "url(#crown-2_svg__A)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21534",
    d: "M100.753 106.825a4.317 4.317 0 0 1-4.053.233l2.116 1.194 4-2V104a3.533 3.533 0 0 1-2.06 2.828z",
    transform: "translate(11.038 13.341)",
    style: {
      fill: "#fff",
      opacity: 0.65,
      fillRule: "evenodd",
      isolation: "isolate",
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21535",
    d: "M102.284 113.2a4.428 4.428 0 0 1 3.788.687l-1.9-1.554-3.353.952v1.584c.007-.786.381-1.311 1.462-1.669z",
    transform: "translate(13.03 17.37)",
    style: {
      opacity: 0.45,
      fill: "#fff",
      fillRule: "evenodd",
      isolation: "isolate",
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21536",
    d: "m97 107.372 6.114-3.061v-.966l-7.021 3.515.907.512z",
    transform: "translate(10.743 13.026)",
    style: {
      fill: "url(#crown-2_svg__B)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21537",
    d: "M97.857 117.092 97 106.227l-.907-.512.956 12.043.813-.667z",
    transform: "translate(10.743 14.171)",
    style: {
      fill: "url(#crown-2_svg__C)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21538",
    d: "m102.8 114.877-5.252-1.491-.813.667 6.065 1.722v-.9z",
    transform: "translate(11.054 17.877)",
    style: {
      fill: "url(#crown-2_svg__h)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21539",
    d: "m106.936 107.372-6.114-3.061v-.966l7.021 3.515-.907.512z",
    transform: "translate(13.029 13.026)",
    style: {
      fill: "url(#crown-2_svg__D)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21540",
    d: "m104.363 117.092.862-10.865.907-.512-.956 12.043-.813-.667z",
    transform: "translate(14.74 14.171)",
    style: {
      fill: "url(#crown-2_svg__E)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21541",
    d: "m100.822 114.877 5.252-1.491.813.667-6.065 1.722v-.9z",
    transform: "translate(13.029 17.877)",
    style: {
      fill: "url(#crown-2_svg__F)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21542",
    d: "M96.359 106.592a9.641 9.641 0 0 0 6.2-3.106l-6.2 3.106z",
    transform: "translate(10.873 13.094)",
    style: {
      fill: "#fffce3",
      opacity: 0.7,
      fillRule: "evenodd",
      isolation: "isolate",
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 35354"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21543",
    d: "M102.473 86.791A5.069 5.069 0 1 1 97.4 91.86a5.07 5.07 0 0 1 5.069-5.069z",
    transform: "translate(11.378 5.028)",
    style: {
      fill: "url(#crown-2_svg__G)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21544",
    d: "M101.7 87.239a3.872 3.872 0 1 1-3.87 3.871 3.872 3.872 0 0 1 3.872-3.871z",
    transform: "translate(11.584 5.244)",
    style: {
      fill: "url(#crown-2_svg__e)",
      fillRule: "evenodd",
      isolation: "isolate",
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21545",
    d: "M99.2 88.5c1.136-1.136 2.762-1.353 3.631-.483s.651 2.493-.485 3.629-2.762 1.353-3.629.485-.653-2.495.483-3.631z",
    transform: "translate(11.752 5.361)",
    style: {
      fill: "url(#crown-2_svg__H)",
      fillRule: "evenodd",
      isolation: "isolate",
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21546",
    d: "M103.816 87.446a4.668 4.668 0 0 1-4.448 8.185 4.824 4.824 0 0 0 4.448-8.185z",
    transform: "translate(12.327 5.344)",
    style: {
      fill: "url(#crown-2_svg__I)",
      fillRule: "evenodd",
      isolation: "isolate",
      mixBlendMode: "screen"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21547",
    d: "M110.829 92.845a8.093 8.093 0 1 1-8.093-8.093 8.093 8.093 0 0 1 8.093 8.093z",
    transform: "translate(10.044 4.043)",
    style: {
      fill: "url(#crown-2_svg__J)",
      fillRule: "evenodd",
      isolation: "isolate",
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21548",
    d: "M107.835 108.213a6.387 6.387 0 1 1-6.386-6.386 6.387 6.387 0 0 1 6.386 6.386z",
    transform: "translate(10.247 12.292)",
    style: {
      fill: "url(#crown-2_svg__K)",
      fillRule: "evenodd",
      isolation: "isolate",
      mixBlendMode: "screen"
    }
  })));
};

export default SvgCrown2;